import { HttpInterceptorFn } from '@angular/common/http';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const token = sessionStorage.getItem('ARP_Token');

  const authReq = token ? req.clone({ setHeaders: { Authorization: `Token ${token}` } }) : req;

  return next(authReq);
};
